var Title = {

  wWidth: undefined,

  flgSp: false,

  path: undefined,

  stage: undefined,
  renderer: undefined,

  ttlImg:undefined,

  sWidth: undefined,
  sHeight: undefined,

  texture: undefined,
  sprite: undefined,

  displacementFilter: undefined,

  count: undefined,

  countX: 0,
  countY: 0,

  init: function() {
    this.defineWsize();
    this.definePath();
    this.setTtlImg();
    if ($('#js-c-page-ttl')[0]) {
      this.setTitleSize();
      this.setStage();
      this.setRenderer();
      this.createObj();
      this.addStage();
      this.setFilter();
      this.render();
      // this.resize();
    }
  },

  definePath: function() {
    this.path = location.pathname.split('/')[1];

// aboutだった場合さらに分岐
    if(this.path === 'about'){
      this.path = location.pathname.split('/')[2];
      if(this.path === ''){
        // インデックスだった場合
        this.path = '/about/index';
      } else {
        this.path = '/about/' + this.path;
      }
    }

    if(this.path === 'participate'){
      this.path = location.pathname.split('/')[2].split('.')[0];
      if(this.path === ''){
        // インデックスだった場合
        this.path = '/participate/index';
      } else {
        this.path = '/participate/' + this.path;
      }
    }


    if(this.path === 'news') {
      this.path = location.pathname.split('/')[2].split('.')[0];
      if (this.path === '') {
        // インデックスだった場合
        this.path = '/news/index';
      } else {
        this.path = '/news/' + this.path;
      }
    }

    if(this.path === 'report'){
      this.path = location.pathname.split('/')[3];
      this.path = '/report/vol/' + this.path;
    }

    if(this.path === 'en'){
      this.path = location.pathname.split('/')[2].split('.')[0];
      if(this.path === ''){
        // インデックスだった場合
        this.path = '/en/index';
      } else {
        this.path = '/en/' + this.path;
      }
    }
  },

  defineWsize: function() {
    this.wWidth = $(window).width();
    if(this.wWidth < 1000) {
      this.flgSp = true;
    }
  },

  resize: function() {
    var timer = false;
    $(window).resize(function() {
      var _this = this;
        if (timer !== false) {
            clearTimeout(timer);
        }
        timer = setTimeout(function() {
    _this.defineWsize();
      _this.setStage();
        }, 200);
    }.bind(this));
  },

  setTtlImg: function() {
    this.ttlImg = '/assets/img' + this.path + '/pageTtl.png';
  },

  setTitleSize: function() {
    if(this.flgSp){
      this.sWidth = this.wWidth;
      this.sHeight =50;
    } else {
      this.sWidth = 1000;
      this.sHeight =90;
    }
  },

  setStage: function() {
    this.stage = new PIXI.Stage(this.sWidth,this.sHeight);
  },

  setRenderer: function() {
    var _scale = window.devicePixelRatio;
    var _target = document.getElementById("js-c-page-ttl");
    this.renderer = new PIXI.autoDetectRenderer(this.sWidth * 2, this.sHeight * 2,{ transparent: true });
    // _target.width = this.sWidth;
    // _target.height = this.sHeight;
    _target.appendChild(this.renderer.view);
  },

  setFilter: function() {
    this.displacementFilter = new PIXI.filters.DisplacementFilter(PIXI.Sprite.fromImage("/assets/img/common/bg_ttl_01.png"));
    this.sprite.filters = [ this.displacementFilter ];
    this.displacementFilter.scale.x = 30;
    this.displacementFilter.scale.y = 30;
  },

  createObj: function() {
    this.texture = new PIXI.Texture.fromImage(this.ttlImg);
    this.sprite = new PIXI.Sprite(this.texture);
    this.sprite.position.x = 0;
    this.sprite.position.y = 0;
    this.sprite.scale.x = 1;
    this.sprite.scale.y = 1;
    if(this.flgSp){
      this.sprite.scale.x = 0.6;
      this.sprite.scale.y = 0.6;
    }
  },

  addStage: function() {
    this.stage.addChild(this.sprite);
  },

  sine: function(x){
    return Math.sin(x * (Math.PI / 180));
  },

  cos: function(x){
    return Math.cos(x * (Math.PI / 180));
  },

  render: function() {
    requestAnimationFrame(this.render.bind(this));
    this.countX+=2;
    this.countY+=1;
    if(this.countX > 360){
      this.countX = 1;
    }
    if(this.countY > 360){
      this.countY = 0.5;
    }

    if(this.flgSp){
      this.displacementFilter.scale.x = this.sine(this.countX) * 5;
      this.displacementFilter.scale.y = this.cos(this.countY) * -25;
    } else {
      this.displacementFilter.scale.x = this.sine(this.countX) * 5;
      this.displacementFilter.scale.y = this.cos(this.countY) * -25;
    }

    this.renderer.render(this.stage);
  }
};



module.exports = Title;


//////////////////
// WEBPACK FOOTER
// ./htdocs_dev/_script/components/pagemodules/_ttl.js
// module id = 3
// module chunks = 0